import { HttpClientInterface } from 'services/http/types';
import { CMS_ALL_NEWS_ENDPOINT, CMS_ONE_POST_ENDPOINT, POSTS_RELATED_LIMIT } from 'config/cms/endpoints';
import { NewsPostList, NewsServiceInterface, NewsSinglePost, PostCollection } from 'services/news/types';
import { normalizePost } from 'services/news/helpers';

interface GetAllPosts {
  data: NewsPostList[];
  meta: { filter_count: number };
}

class NewsService implements NewsServiceInterface {
  constructor(private readonly client: HttpClientInterface) {}

  async getAllPosts(page: number, filter = '', limit?: number): Promise<PostCollection> {
    const { data } = await this.client.get<GetAllPosts>(CMS_ALL_NEWS_ENDPOINT(page, filter, limit));
    // @ts-ignore
    return { data: data.data.map(normalizePost), total: data.meta.filter_count };
  }

  async getOnePost(link: string): Promise<NewsSinglePost> {
    const { data } = await this.client.get<{ data: NewsSinglePost }>(CMS_ONE_POST_ENDPOINT(link));
    // @ts-ignore
    return normalizePost(data.data[0]);
  }

  async getRelatedPosts(id: string): Promise<Array<NewsPostList>> {
    return await this.getAllPosts(1, `filter[id][_neq]=${id}`, POSTS_RELATED_LIMIT).then((data) => data.data);
  }
}

export default NewsService;
